export enum SubscriptionEnum {
    Brand = 1, // LEGACY BRAND
    Agency = 2,
    PayAsYouGo = 3,
    Essentials = 4,
    Pro = 5
}

export enum PeriodEnum {
    Year = 'year',
    Month = 'month',
}

export interface CreateSubSession {
    stripeCustomerId: string;
    subscription: SubscriptionEnum;
    successUrl: string;
    cancelUrl: string;
    currencyCode: string;
    billingPeriod: PeriodEnum
}

export interface CreateSubSessionMultiProduct {
    stripeCustomerId: string;
    products: {
        productId: string;
        quantity: number;
    }[];
    successUrl: string;
    cancelUrl: string;
}

export interface BoltOn {
    stripe_id: string;
    id: string;
    name: string;
    price: number;
    description: string;
    icon: string;
    mode_details: string[]
}

export interface SubscriptionPlan {
    stripe_id: string;
    id: string;
    name: string;
    price: number;
    description: string;
    features: string[];
    popular?: boolean;
}